import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { LocalizedNavigate } from '../localization/components/LocalizedNavigate'
import { getLangPrefix } from '../localization/utils/localization'
import AboutPage from '../pages/AboutPage'
import ContactPage from '../pages/ContactPage'
import ExercisePage from '../pages/ExercisePage'
import HomePage from '../pages/HomePage'
import PendulumPage from '../pages/PendulumPage'
import ServicesPage from '../pages/ServicesPage'
import TherapyPage from '../pages/TherapyPage'
import WorkshopsPage from '../pages/WorkshopsPage'
import NotFound from '../views/NotFound'
import App from './App'
import AppLocalization from './AppLocalization'

export default function AppRouter() {
  const createAppRoutes = (lang: string) => {
    const prefix = getLangPrefix(lang)

    return {
      path: prefix,
      element: <AppLocalization lang={lang} />,
      children: [
        {
          path: '',
          element: <App />,
          children: [
            { path: '', element: <HomePage /> },
            { path: 'pendulum', element: <PendulumPage /> },
            { path: 'therapy', element: <TherapyPage /> },
            { path: 'exercise', element: <ExercisePage /> },
            { path: 'about', element: <AboutPage /> },
            { path: 'services', element: <ServicesPage /> },
            { path: 'workshops', element: <WorkshopsPage /> },
            { path: 'contact', element: <ContactPage /> }
          ]
        },
        { path: '404', element: <NotFound /> }
      ],
      errorElement: <LocalizedNavigate to="/404" replace />
    }
  }

  const router = createBrowserRouter([createAppRoutes('cs'), createAppRoutes('sk'), createAppRoutes('en')])

  return <RouterProvider router={router} />
}
